import styled from 'styled-components';

import {border, colors} from 'theme';

export const Control = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;

    & > div {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    & > h2 {
        margin: 0;
        font-size: 20px;
        font-weight: 600;
    }
`;

export const FilterContainer = styled.div`
    width: 330px;
    background: rgb(255, 255, 255);
    box-shadow: 0 1px 13px rgba(0, 0, 0, 0.1);
    position: absolute;
    padding: 12px 20px 20px 20px;
    box-sizing: border-box;
    top: 45px;
    left: 0;
    z-index: 1;
    transition: all 1s linear;
    &.visible {
        visibility: visible;
        display: block;
        opacity: 1;
        transition: opacity 0.15s linear;
    }
    &.hidden {
        visibility: hidden;
        display: none;
        opacity: 0;
        transition: visibility 0s 0.15s, opacity 0.15s linear;
    }
`;

export const FilterTitle = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
`;

export const FilterControl = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin-top: 10px;

    & > * {
        width: 100%;
    }
`;

export const MapWrapper = styled.section`
    width: 100%;
    min-width: 0;
    grid-column: 1 / -1;
    box-sizing: border-box;
    padding: 20px;
    background-color: ${colors.white};
    border-radius: ${border.radius};
`;
export const MapTitle = styled.h2`
    margin: 0;
    font-size: 16px;
    font-weight: 500;
`;
export const MapDescription = styled.p`
    margin: 12px 0 15px;
    color: ${colors.textSecondary};
    font-size: 12px;
`;
export const MapCanvas = styled.div`
    position: relative;
    height: 500px;
    .map-loading {
        position: absolute;
        top: 12px;
        left: 50%;
        pointer-events: none;
    }
`;
export const Popup = styled.aside`
    position: absolute;
    top: 60px;
    right: 12px;
    max-height: calc(100% - 80px);
    width: 320px;
    max-width: calc(100% - 24px);
    overflow-y: auto;
    box-sizing: border-box;
    background: ${colors.white};
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 12px 32px rgba(52, 52, 52, 0.16);
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
export const FilterRow = styled.form`
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr)) auto;
    gap: 12px;
    align-items: end;
    margin-bottom: 16px;
    > * {
        min-width: 0;
    }
    @media (max-width: 900px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (max-width: 600px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;
export const FilterActions = styled.div`
    display: flex;
    gap: 8px;
    > button {
        width: auto;
        white-space: nowrap;
    }
`;
export const ProductGroupLabel = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    font-size: 12px;
    line-height: 20px;
    > :first-child {
        flex-shrink: 0;
    }
    > span:last-child {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
export const Legend = styled.details`
    position: absolute;
    top: 60px;
    left: 12px;
    z-index: 1;
    max-width: calc(100% - 24px);
    max-height: calc(100% - 80px);
    overflow-y: auto;
    box-sizing: border-box;
    background: ${colors.white};
    border-radius: ${border.radius};
    box-shadow: 0 2px 8px rgba(52, 52, 52, 0.16);
    font-size: 12px;
    summary {
        cursor: pointer;
        padding: 8px 12px;
        font-weight: 500;
    }
    > ul {
        display: grid;
        gap: 6px;
        margin: 0;
        padding: 8px 12px 12px;
        list-style: none;
    }
    li {
        display: flex;
        align-items: center;
        gap: 8px;
        line-height: 16px;
    }
`;
